module.exports = __webpack_public_path__ + "static/media/your-say.b8a9bcb7.svg";